// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"b1bd107e","160":"4fbc0650","208":"7fc5c8c5","293":"bc59732f","312":"52c2f608","516":"9d6de86e","519":"6aa65b94","653":"b50e2a88","885":"04677621","917":"29c7b13b","946":"376cd19c"}[chunkId] + ".chunk.js";
};